import store from "./redux/store";
import { useDispatch, useSelector } from "react-redux";
import { domainUrl } from "./constants/apiconstans/domanUrl";
import { actionsApi } from "./redux/actionsApi";
import {
  loadAllAppointments,
  changeAllAppointmentsFilters,
  setPagination,
  removeAppointment,
} from "./redux/action/appointments/AllAppointments";
const useShareDispatch = () => useDispatch();
const useShareSelector = useSelector;
export {
  store,
  useShareDispatch,
  useShareSelector,
  domainUrl,
  actionsApi,
  loadAllAppointments,
  changeAllAppointmentsFilters,
  setPagination,
  removeAppointment,
};
export * from "./helpers";
export * from "./lookups";
export * from "./Apis";
